<template>
  <section :class="['container',$store.state.common.theme==3?'container_theme3':'' ]"   >
    <me-header v-if="$store.state.common.theme!=3"  :common="common" :showPoint="showPoint" :integration="common.myHeaderDate.integrationSum"
    :level="common.myHeaderDate.level" :levelBgStyle="common.myHeaderDate.levelBgStyle"></me-header>
    <me-header3 v-if="$store.state.common.theme==3"  :common="common" :showPoint="showPoint" :integration="common.myHeaderDate.integrationSum"
    :level="common.myHeaderDate.level" :levelBgStyle="common.myHeaderDate.levelBgStyle"></me-header3>
    <tab-list></tab-list>
    <mt-popup v-model="isShowAdvertisement" position="center" pop-transition="popup-fade" :closeOnClickModal='clickfalse' >
      <advertisementMask
        :mbMaskingAds="mbMaskingAds"
        @getCoupon="getCoupon"
        @closeCoupon="closeCoupon"
      ></advertisementMask>
    </mt-popup>
    <nav-bar :tab="3"></nav-bar>
  </section>
</template>

<script>
import MeHeader from "./components/me-header.vue";

import MeHeader3 from "./components/me-header_3.vue";
import TabList from "./components/me-tablist.vue";
import NavBar from "../../components/navbar";
import { mapState, mapActions } from "vuex";
import storage from '../../utils/storage';
import advertisementMask from "../../components/advertisementMask"
import util from "../../utils/util";
import {getUserTenantListByUserId,getMsgCount,uploadWapFile ,getUserByRelationId ,addMbBond,getMaskingAds} from '../../utils/api'
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: "me",
  components: {
    MeHeader,
    MeHeader3,
    NavBar,
    TabList,
    advertisementMask
  },
  data() {
    return {
      testImg:'',
      showPoint:false,
      marketId:'',
      integrationSum:0,
      integration:'', //会员等级数据
      level:'',
      levelBgStyle:'',
      isShowAdvertisement:false,
      clickfalse:false,
      mbMaskingAds:{},
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  activated(){
    
    if(this.common.userId){
        this.getUserTenantListByUserId()
        this.getMsgCount();
        this.getMaskingAds();
        this.getUserByRelationId(); //刷新积分
        // if(!this.common.myHeaderDate.level){
        //   this.getUserByRelationId();
        // }
    }
  },
  methods: {
    ...mapActions(['getTenantInfo','getTenantInfoList','getMyHeaderDate']),
    // 获取用户认证企业信息
    getUserTenantListByUserId() {
      getUserTenantListByUserId({userId:this.common.userId}).then(res => {
          console.log(res);
          if(res.body && res.res && res.res.code == 10000){
            this.getTenantInfoList(res.body.userTenantList)
            res.body.userTenantList.forEach(item=>{
              if(item.isDeafult == 1){
                this.getTenantInfo(item)
              }
            })
          }else{
            this.getTenantInfoList([])
            this.getTenantInfo({})
          }
        })
    },
    getMsgCount(){
      getMsgCount({userId:this.common.userId}).then(res=>{
        console.log(res)
        if(res.res.code == 10000 && res.body){
          if(res.body.msgCount > 0){
            this.showPoint = true
          }else{
            this.showPoint = false
          }
        }
      })
    },
    chooseImg(){
      let that = this;
      wx.ready(()=>{
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original','compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            console.log(res)
            console.log(res.localIds[0])
            wx.uploadImage({
              localId: res.localIds[0],
              isShowProgressTips: 1,
              success: function (ret) {
                // 返回图片的服务器端ID
                var serverId = ret.serverId;
                that.uploadWapFile(serverId)
              }
            })
          }
        })
      })
    },
    uploadWapFile(id){
      let params = {
        mediaId:id,
        marketId:this.common.marketInfo.id
      }
      uploadWapFile(params).then(res=>{
        console.log(res)
        this.testImg = res.body.imgUrl
      })
    },
    getUserByRelationId(){
      let params = {
        memberCode: this.common.userInfo.memberCode,
        marketId: this.common.marketInfo.id
      };
      getUserByRelationId(params).then(res => {
        console.log(res)
        if (res.res.code === 10000 && res.body) {
          this.getMyHeaderDate(res.body)
          console.log('res.body.level   ====  ' ) 
        }
      });
    },
     getCoupon () {
      addMbBond({
        memberCode: this.common.userInfo.memberCode,
        activeId: this.mbMaskingAds.bondActiveId,
        marketId: this.common.marketInfo.id,
        templateId: this.mbMaskingAds.templateId,
        beginTime: this.mbMaskingAds.beginTime.split('.').join(''),
        endTime: this.mbMaskingAds.endTime.split('.').join('')
      }).then(res => {
       // console.log(res);
        if (res.res.code === 10000) {
          util.showToast('领取成功，请至我的优惠券查看');
        } else {
          util.showToast(res.res.msg);
        }
        this.isShowAdvertisement = false;
      }
      );
    },
    closeCoupon () {
      this.isShowAdvertisement = false;
    },
     getMaskingAds () {
      if (!this.common.userId) {
        return;
      }
      getMaskingAds({
        memberCode: this.common.userInfo.memberCode,
        marketId: this.common.marketInfo.id,
        // actType: '2', // 2商业
        displayPosition: '1' // 显示在首页 ；1:显示在我的页面
      }).then(res => {
        // console.log("in getMaskingAds")
        // console.log(res);
        if (res && res.res.code === 10000 && res.body.mbMaskingAds) {
          if(res.body.mbMaskingAds && res.body.mbMaskingAds!=null){
              this.mbMaskingAds = res.body.mbMaskingAds
          }else{
              this.mbMaskingAds='';
          }
          // displayCondition 0:首次进入显示，1:每次进入显示
         //  storage.removeS('displayConditionArray');
          if (res.body.mbMaskingAds.perm) {
             let displayCondition = storage.getS('displayConditionArray') ;
                let arr =[];
                if(displayCondition){
                  arr =JSON.parse(displayCondition )
                }
                var hasSave=false;
                for(var i=0;i<arr.length;i++){
                  if(arr[i]==res.body.mbMaskingAds.id){
                    hasSave =true;
                    break;
                  }
                }

            if (
              res.body.mbMaskingAds.displayCondition == 0 &&
              hasSave
            ) {
              this.isShowAdvertisement = false;
            } else {
              if(!this.mbMaskingAds){
                this.isShowAdvertisement = false;
              }else{
               //  storage.removeS('displayConditionArray');
                this.isShowAdvertisement = true;
              }

              if (res.body.mbMaskingAds.displayCondition == 0) {
                let displayCondition = storage.getS('displayConditionArray') ;
                let arr =[];
                if(displayCondition){
                  arr =JSON.parse(displayCondition )
                }
                arr.push(res.body.mbMaskingAds.id)
                storage.setS(
                  'displayConditionArray', JSON.stringify(arr));
              }
            }
          }
          if (res.body.mbMaskingAds.discountMode === 2) {
            res.body.mbMaskingAds.amountDiscount = (
              res.body.mbMaskingAds.amountDiscount / 10
            ).toFixed(1);
          }
          // this.mbMaskingAds = res.body.mbMaskingAds;
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  background:#fafafa;
  .me_bg_icon{
    position: fixed;
    bottom:38px;
    width:390px;
    height:auto;left:50%;
    transform: translateX(-50%);
  }

}
.container_theme3{
  background:#fff;
}
</style>